import { interfaces as I } from '@leandredev/dcbm-common-lib';
import { WorkSheet } from 'xlsx';

export enum ReportSelectionImportMode {
  MONTHLY = 'montlhy',
  YEARLY = 'yearly',
  LOCATION = 'location',
  GALLERY = 'gallery'
}
export interface IDataAnalyseResult {
  inFile: string[];
  inDb: string[];
  toCreate: string[];
  toUpdate: string[];
  missingColumns: string[];
}

export interface IRow {
  denomination: string;
  n_loc: string;
  n_prop: string;
}

export interface IRowGal {
  denomination: string;
  n_lolita: string;
}

export interface IUploadLoctionResult {
  existing: string[];
  toCreate: string[];
  newData: I.IAct[];
  acts: I.IAct[];
  toUpdate: any[];
  errors: { err: any; data: any; state: string }[];
}

export const SHEET_NAME = {
  gallery: 'Prop',
  location: 'Loc'
};

export interface IRentMonthlyRepportResult {
  error: string[];
  rentrepports: I.IRentReportMonthly[];
  actsForUpdate: Partial<I.IAct>[];
}

export interface IRentYearlyRepportResult {
  error: string[];
  rentrepports: I.IRentReportYearly[];
  actsForUpdate: Partial<I.IAct>[];
}

// =============================================================================
// INTERFACE
// =============================================================================

// Galerry Interface ==========================================================

export interface I_GAL_ROW<T> {
  n_lolita: T;
  statut: T;
  denomination: T;
  forme: T;
  siren: T;
  rcs: T;
  adresse_1: T;
  adresse_2: T;
  code_postal: T;
  ville: T;
  civilite: T;
  adherent: T;
  mail_adherent: T;
  centrale: T;
}

export type PROP_ROW_NAME = keyof I_GAL_ROW<any>;

export const GAL_COL_NAME: Array<PROP_ROW_NAME> = [
  'n_lolita',
  'statut',
  'denomination',
  'forme',
  'siren',
  'rcs',
  'adresse_1',
  'adresse_2',
  'code_postal',
  'ville',
  'civilite',
  'adherent',
  'mail_adherent',
  'centrale'
];

export const IMP_GAL_COL_NAME: Array<{ name: PROP_ROW_NAME; required: boolean }> = [
  { name: 'n_lolita', required: true },
  { name: 'statut', required: true },
  { name: 'denomination', required: true },
  { name: 'forme', required: true },
  { name: 'siren', required: true },
  { name: 'rcs', required: true },
  { name: 'adresse_1', required: true },
  { name: 'adresse_2', required: true },
  { name: 'code_postal', required: true },
  { name: 'ville', required: true },
  { name: 'civilite', required: true },
  { name: 'adherent', required: true },
  { name: 'mail_adherent', required: true },
  { name: 'centrale', required: true }
];

export function hasAllRequiredGalleryColname(col: string[]): string[] {
  const res: string[] = [];

  IMP_GAL_COL_NAME.forEach((impCol) => {
    if (impCol.required && !col.includes(impCol.name)) res.push(impCol.name);
  });

  return res;
}

// LOCATION Interface ==========================================================

export interface I_LOC_ROW<T> {
  n_loc: T;
  statut: T;
  preneur: T;
  forme: T;
  enseigne: T;
  secteur_d_activite: T;
  surface_exploite: T;
  n_prop: T;
  proprietaire: T;
  situation_du_lot: T;
  date_de_bail: T;
  periodicite: T;
}

export type LOC_ROW_NAME = keyof I_LOC_ROW<any>;

export const LOC_COL_NAME: Array<LOC_ROW_NAME> = [
  'n_loc',
  'statut',
  'preneur',
  'forme',
  'enseigne',
  'secteur_d_activite',
  'surface_exploite',
  'n_prop',
  'proprietaire',
  'situation_du_lot',
  'date_de_bail',
  'periodicite'
];

export const IMP_LOC_COL_NAME: Array<{ name: LOC_ROW_NAME; required: boolean }> = [
  { name: 'n_loc', required: true },
  { name: 'statut', required: true },
  { name: 'preneur', required: true },
  { name: 'forme', required: true },
  { name: 'enseigne', required: true },
  { name: 'secteur_d_activite', required: true },
  { name: 'surface_exploite', required: true },
  { name: 'n_prop', required: true },
  { name: 'proprietaire', required: true },
  { name: 'situation_du_lot', required: true },
  { name: 'date_de_bail', required: true },
  { name: 'periodicite', required: true }
];

export function hasAllRequiredLocationColname(col: string[]): string[] {
  const res: string[] = [];

  IMP_LOC_COL_NAME.forEach((impCol) => {
    if (impCol.required && !col.includes(impCol.name)) res.push(impCol.name);
  });

  return res;
}

// YEAR Interface ==============================================================

export const YEARLYREPORT_KEY: Array<keyof I.IRentReportYearly> = [
  'name',
  'internalDcbmReference',
  'startDateRentalContract',
  'situation_du_lot',
  'year',
  'rentNumber',
  'state',
  'smp',
  'rentHt',
  'expanseHt',
  'tfHt',
  'totalYearlyHt',
  'totalTermHt',
  'turnover',
  'stressRate'
];

export interface I_YEAR_ROW<T> {
  proprietaire: T;
  situation_du_lot: T;
  date_de_bail: T;
  periodicite: T;
  ppm: T;
  loyer_annuel_ht: T;
  charges_annuelles_ht: T;
  tf_ht: T;
  total_annuel_ht: T;
  total_echeance_ht: T;
  ca_ht: T;
  taux_effort: T;
}

export type YEAR_ROW_NAME = keyof I_YEAR_ROW<any>;

export const YEAR_COL_NAME: Array<YEAR_ROW_NAME> = [
  'proprietaire',
  'situation_du_lot',
  'date_de_bail',
  'periodicite',
  'ppm',
  'loyer_annuel_ht',
  'charges_annuelles_ht',
  'tf_ht',
  'total_annuel_ht',
  'total_echeance_ht',
  'ca_ht',
  'taux_effort'
];

export const IMP_YEAR_COL_NAME: Array<{ name: YEAR_ROW_NAME; required: boolean }> = [
  { name: 'proprietaire', required: true },
  { name: 'situation_du_lot', required: true },
  { name: 'date_de_bail', required: true },
  { name: 'periodicite', required: true },
  { name: 'ppm', required: true },
  { name: 'loyer_annuel_ht', required: true },
  { name: 'charges_annuelles_ht', required: true },
  { name: 'tf_ht', required: true },
  { name: 'total_annuel_ht', required: true },
  { name: 'total_echeance_ht', required: true },
  { name: 'ca_ht', required: true },
  { name: 'taux_effort', required: true }
];

export function hasAllRequiredYearColname(col: string[]): string[] {
  const res: string[] = [];

  IMP_YEAR_COL_NAME.forEach((impCol) => {
    if (impCol.required && !col.includes(impCol.name)) res.push(impCol.name);
  });

  return res;
}

// MONTH Interface =============================================================

export interface I_MONTH_ROW<T> {
  n_loc: T;
  statut: T;
  n_prop: T;
  bailleur: T;
  preneur: T;
  enseigne: T;
  periode_de_facturation: T;
  periode: T;
  echeance: T;
  date_echeance: T;
  paye: T;
  arriere: T;
  autres_factures: T;
  paiements_effectues: T;
  avoir_emis: T;
  total_du: T;
  ca_ht_mensuel: T;
  taux_effort: T;
  cumul_echeance: T;
  total_du_ht: T;
}

export type MONTH_ROW_NAME = keyof I_MONTH_ROW<any>;

export const MONTH_COL_NAME: Array<MONTH_ROW_NAME> = [
  'n_loc',
  'statut',
  'n_prop',
  'bailleur',
  'preneur',
  'enseigne',
  'periode_de_facturation',
  'periode',
  'echeance',
  'date_echeance',
  'paye',
  'arriere',
  'autres_factures',
  'paiements_effectues',
  'avoir_emis',
  'total_du',
  'ca_ht_mensuel',
  'taux_effort',
  'cumul_echeance',
  'total_du_ht'
];

export const IMP_MONTH_COL_NAME: Array<{ name: MONTH_ROW_NAME; required: boolean }> = [
  { name: 'n_loc', required: true },
  { name: 'statut', required: true },
  { name: 'n_prop', required: true },
  { name: 'bailleur', required: true },
  { name: 'preneur', required: true },
  { name: 'enseigne', required: true },
  { name: 'periode_de_facturation', required: true },
  { name: 'periode', required: true },
  { name: 'echeance', required: true },
  { name: 'date_echeance', required: true },
  { name: 'paye', required: true },
  { name: 'arriere', required: true },
  { name: 'autres_factures', required: true },
  { name: 'paiements_effectues', required: true },
  { name: 'avoir_emis', required: true },
  { name: 'total_du', required: false },
  { name: 'ca_ht_mensuel', required: true },
  { name: 'taux_effort', required: true },
  { name: 'cumul_echeance', required: true },
  { name: 'total_du_ht', required: true }
];

export function hasAllRequiredMonthColname(col: string[]): string[] {
  const res: string[] = [];

  IMP_MONTH_COL_NAME.forEach((impCol) => {
    if (impCol.required && !col.includes(impCol.name)) res.push(impCol.name);
  });

  return res;
}

export interface I_Sheets {
  name: string;
  value: WorkSheet;
  missingColums: string[];
}
